import React from 'react';

export default function ErrorPage() {
  return (
    <div style={{ textAlign: 'center', marginTop: '4rem' }}>
      <h1>Something went wrong</h1>
      <p>
        The invitation link is invalid or has expired.<br />
        Please contact support or request a new invitation.
      </p>
    </div>
  );
}